import api from "./api.ts";
import type { AxiosResponse } from "axios";
import type { Classroom } from "../interfaces/classroom.interface.ts";
import type { Enrollment } from "../interfaces/enrollment.interface.ts";
import type { IClassroomDetails } from "../interfaces/classroomDetails.interface.ts";
import type { IStudentProgress } from "../interfaces/IStudentProgress.interface.ts";

export async function createClassroom(name: string, joinCode: string): Promise<Classroom> {
    const response: AxiosResponse<Classroom> = await api.post("classroom/create", { name, joinCode });
    return response.data;
}

export async function removeClassroom(classroomId: number): Promise<boolean> {
    const response: AxiosResponse<boolean> = await api.delete(`classroom/${classroomId}`);
    return response.data;
}

export async function getStudents(classroomId: number): Promise<Enrollment[]> {
    const response: AxiosResponse<Enrollment[]> = await api.get(`classroom/${classroomId}/students`);
    return response.data;
}

export async function removeStudent(classroomId: number): Promise<boolean> {
    const response: AxiosResponse<boolean> = await api.delete(`classroom/${classroomId}/student`);
    return response.data;
}

export async function getClassroomRole(): Promise<{ role: 'teacher' | 'student' | 'none'; classroomId?: number }> {
    const response: AxiosResponse<{ role: 'teacher' | 'student' | 'none'; classroomId?: number }> =
        await api.get("classroom/role");
    return response.data;
}

export async function joinByCode(joinCode: string): Promise<Enrollment> {
    const response: AxiosResponse<Enrollment> =
        await api.post("classroom/join", { joinCode });
    return response.data;
}

export async function leaveClassroom(): Promise<boolean> {
    const response: AxiosResponse<boolean> = await api.delete("classroom/leave")
    return response.data
}

export async function getClassroom(): Promise<Classroom> {
    const response: AxiosResponse<Classroom> = await api.get("classroom/current")
    return response.data
}

export async function getClassroomDetails(): Promise<IClassroomDetails> {
const response: AxiosResponse<IClassroomDetails> = await api.get('/classroom/details');
return response.data;
}

export async function getStudentProgress(classroomId: number): Promise<IStudentProgress[]> {
    const response: AxiosResponse<IStudentProgress[]> = await api.get(`classroom/${classroomId}/progress`);
    return response.data;
}